<template>
  <v-dialog
    :value="dialog"
    :width="1000"
    persistent
    :retain-focus="false"
    @keydown.esc="escape(closeDialog)"
    @click:outside="escape(closeDialog)"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('note.updateNote') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <v-row class="pt-5">
              <v-col>
                <v-text-field
                  v-model.trim="editedNote.title"
                  :label="$t('note.edit.title')"
                  :rules="rules.title"
                  type="text"
                  prepend-icon="mdi-text-short"
                  tabindex="1"
                  clearable
                  validate-on-blur
                  autofocus
                >
                </v-text-field>
                <div class="mt-4 ml-9">
                  <PSyncfusionRichTextEditor
                    v-model="editedNote.text"
                    :label="$t('note.edit.text')"
                    :height="500"
                    tabindex="1"
                  />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn tabindex="3" text @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn :disabled="!isModelChanged()" color="primary" tabindex="2" text @click="submit">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'
import PSyncfusionRichTextEditor from '@/components/PSyncfusionRichTextEditor'

import snackbarMixin from '@/mixins/snackbar.mixin'
import objectMixin from '@/mixins/object.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'

export default {
  components: {
    PBtnIcon,
    PSyncfusionRichTextEditor
  },


  mixins: [
    snackbarMixin,
    objectMixin,
    dialogMixin,
    validationMixin,
    unsavedChangesMixin
  ],


  props: {
    note: Object
  },


  data () {
    return {
      editedNote: {}
      // editedNoteWatchedModel: {}
    }
  },


  computed: {
    rulesToApply () {
      const rule = this.rule

      return {
        title: [rule.required()]
      }
    }
  },


  methods: {
    ...mapActions('note', ['updateNote']),
    ...mapActions('changes', ['removeFromChanges']),

    // onTitleInput () {
    //   this.updateEditedNoteWatchedModel()
    // },
    //
    // onTextInput () {
    //   this.updateEditedNoteWatchedModel()
    // },
    //
    // updateEditedNoteWatchedModel () {
    //   this.editedNoteWatchedModel = this.getObjectCopy(this.editedNote)
    // },

    onDialogOpen () {
      if (this.note) {
        this.removeFromChanges(this.note)
      }
      this.editedNote = this.getObjectCopy(this.note)
      // this.updateEditedNoteWatchedModel()
      // this.initWatchedModel(this.editedNoteTitle)
      this.resetValidation()
    },


    async submit () {
      const valid = await this.validate(this.rulesToApply)
      // if (!valid || !this.isModelChanged()) return
      if (!valid) return
      try {
        this.showSnackbarProcessing()
        await this.updateNote(this.editedNote)
        this.showSnackbarSuccess(this.$t('note.noteUpdated'))
        this.closeDialog()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
